import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Chip, Typography } from "@mui/material";
import { Table } from "@4uhub/lib4uhub";

import MainApi from "../../../../services/mainApi.service";
import { buildTPath } from "./beneficiarySuspensionsReason.utils";
import { IBeneficiarySuspensionReason } from "../../../../models/beneficiary-suspension-reason";

const serviceURL =
  process.env.REACT_APP_MAIN + "/api/v1/BeneficiaryContractReasonOfSuspension/";

const service = new MainApi<IBeneficiarySuspensionReason>(serviceURL);

const BeneficiarySuspensionReasonPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const translate = (path: string) => t(buildTPath(path));

  const columns: GridColDef<IBeneficiarySuspensionReason>[] = [
    {
      field: "code",
      headerName: t(buildTPath("code"))!,
      renderCell: ({ value }) => (
        <Typography variant="body2">{value}</Typography>
      ),
    },
    {
      field: "name",
      headerName: translate("name"),
    },
    {
      field: "enable",
      maxWidth: 100,
      headerName: translate("status"),
      renderCell: ({ value }) => (
        <Chip
          size="small"
          color={value ? "success" : "error"}
          label={value ? translate("active") : translate("inactive")}
        />
      ),
    },
  ];

  const handleRowClick = ({
    id,
  }: GridRowParams<IBeneficiarySuspensionReason>) => {
    navigate(`${id.toString()}/edit`);
  };

  const handleAdd = () => {
    navigate("new");
  };

  return (
    <Table<IBeneficiarySuspensionReason>
      showDefaultMacroFilters={false}
      service={service}
      columns={columns}
      title={translate("title")}
      searchInput
      onAdd={handleAdd}
      onRowClick={handleRowClick}
      searchInputPlaceHolder={translate("search")}
      addButtonLabel={translate("add")}
      confirmOptions={{
        title: translate("confirm.title"),
        description: translate("confirm.description"),
        confirmationButtonProps: { variant: "contained" },
      }}
    />
  );
};

export default BeneficiarySuspensionReasonPage;
